/*global TTObjectTypeEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Link, Redirect }   from 'react-router-dom';

import { Column, Table, WindowScroller }  from 'react-virtualized';

import { Page, Dialog, MessageBox, Modal } from 'moovila-common';

import Masthead       from '../Masthead';
import AddEditLicense from './AddEditLicense';

import './LicenseMaintenance.css';

class LicenseMaintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisabled: false,
    }
    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.getLicense     = this.getLicense.bind(this);
  }

  toggleDisabled() {
    this.setState({
      showDisabled: !this.state.showDisabled,
    });
  }

  getLicense(guid = '') {
    if (!guid.length) {
      return null;
    }
    return this.props.licenses.filter(l => l.licenseGUID === guid)[0];
  }

  render() {
    const licenses = this.state.showDisabled ? this.props.licenses : this.props.licenses.filter(l => l.isActive);
    let modal = (this.props.method === 'add' || this.props.method === 'edit') && this.props.licenses.length ?
      <AddEditLicense
        method={this.props.method}
        showMessageBox={this.props.showMessageBox}
        license={this.getLicense(this.props.licenseGUID)}
        features={this.props.features}
        updateLicense={this.props.updateLicense}
        setQuestion={this.props.setQuestion}
        history={this.props.history}
      /> : null;

    if (this.props.method === 'delete' && !!this.getLicense(this.props.licenseGUID).assignmentCount) {
      modal = <MessageBox
        title='Cannot Delete License'
        backTo='/admin/license-maintenance'
      >
        This license has assignments. Please remove the assignments before deleting this license.
      </MessageBox>
    } else if (this.props.method === 'delete') { // TODO: check that this license is empty
      if (!this.props.licenses.length) {
        return <Redirect to='/admin/license-maintenance' />;
      }
      modal = (
        <Dialog
          title='Delete License'
          yesText='Delete'
          yesCallback={this.props.deleteLicense}
          backTo={`/admin/license-maintenance/`}
        >
          <div>
            <section className='section'>
              <div className='row'>
                <div className='col-xs-12 form-group text-center'>
                  Are you sure you want to delete '{this.getLicense(this.props.licenseGUID).name}'?
                </div>
              </div>
            </section>
          </div>
        </Dialog>
      );
    }

    if (this.props.method === 'features' && this.props.licenseGUID && this.props.licenses.length && this.props.features.length) {
      const license = this.getLicense(this.props.licenseGUID);
      modal = (
        <MessageBox
          title={`Permissions for ${license.name}`}
          backTo='/admin/license-maintenance'
        >
          {
            this.props.features
              .filter(f => license.permissions.some(lF => lF.code === f.code))
              .map((f, i, arr) => <span key={i}>{f.name}{i === arr.length - 1 ? '' : ', '}</span>)
          }
        </MessageBox>
      );
    }

    if (this.props.method === 'assignments') {
      if (!this.props.licenses.length) {
        return <Redirect to='/admin/license-maintenance' />
      }
      const licenseName = this.getLicense(this.props.licenseGUID).name;
      const assignments = !this.props.assignments ? null : this.props.assignments
        .map((a, k) => (
          <div className='col-xs-12 assignment-item' key={k}>
            <h3>{a.assignee}</h3>
            <p>{a.objectTypeCode === TTObjectTypeEnum.OT_USER ? 'user' : 'enterprise'}</p>
          </div>
        ));
      modal = (
        <Modal
          title={`${licenseName}`}
          backTo='/admin/license-maintenance'
        >
          <div className='row'>
            { assignments }
          </div>
        </Modal>
      );
    }

    return (
      <div className='LicenseMaintenance'>
        <Masthead title='License Maintenance' icon='fa fa-id-card' />
        <div className='EC-sticky-subheader'>
          <div className='row EC-sticky-subheader-inner'>
            <div className='col-xs-10'>
              <Link to='/admin/license-maintenance/add' className='btn btn-primary btn-xl btn-margin-fix' id='UserMaintenance_btnAddUser'>
                  <i className='fa fa-plus-circle icon' aria-hidden='true'></i>
                  Add license
              </Link>
            </div>
            <div className='col-xs-2'>
              <input
                checked={this.state.showDisabled}
                onChange={this.toggleDisabled}
                className='table-footer__checkbox'
                name='RoleMaintenance_chkFilter'
                id='RoleMaintenance_chkFilter'
                type='checkbox' />
              <label className='table-footer__label table-footer__label--checkbox' htmlFor='RoleMaintenance_chkFilter'>Show inactive</label>
            </div>
          </div>
        </div>
        <Page>
          <section className='section'>
            { licenses.length ? (
              <WindowScroller>
                {({ height, isScrolling, scrollTop }) => (
                <Table
                  className='table-bordered'
                  autoHeight
                  height={height}
                  headerHeight={44}
                  isScrolling={isScrolling}
                  scrollTop={scrollTop}
                  rowCount={licenses.length}
                  rowGetter={({index}) => licenses[index]}
                  rowHeight={52}
                  width={992}
                >
                  <Column
                    width={75}
                    label='Status'
                    dataKey='isActive'
                    cellRenderer={({cellData}) => {
                      return cellData === true ?
                        <span className='ellipsis'>Active</span>
                      :
                        <span className='ellipsis'>Inactive</span>
                    }}
                  />
                  <Column
                    width={225}
                    label='License Name'
                    dataKey='name'
                    cellRenderer={({cellData}) => {
                      return cellData === null ? '' :
                        <span className='ellipsis'>{cellData}</span>
                    }}
                  />
                  <Column             // change to permission #s
                    width={200}
                    label='Features'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData, rowData}) => {
                      const permissions = rowData.permissions;
                      return cellData === null ? '' : (
                        <div className='text-center'>
                          <Link className='heavy-anchor' to={`/admin/license-maintenance/features/${cellData}`}>
                            <span className='ellipsis text-center'>{permissions.length} {permissions.length === 1 ? <span>Permission</span> : <span>Permissions</span>}</span>
                          </Link>
                        </div>
                      );
                    }}
                  />
                  <Column
                    width={200}
                    label='Assignments'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData, rowData}) => {
                      return cellData === null ? '' : (
                        <div className='text-center'>
                          {/* <Link className='heavy-anchor' to={`/admin/license-maintenance/assignments/${cellData}`}> */}
                            <span className='ellipsis text-center'>View assignments (disabled)</span>
                          {/* </Link> */}
                        </div>
                      );
                    }}
                  />
                  <Column
                    width={162}
                    label=''
                    dataKey='licenseGUID'
                    cellRenderer={() => null}
                  />
                  <Column
                    width={66}
                    label='Edit'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData}) => {
                      return cellData === null ? '' : (
                        <Link to={`/admin/license-maintenance/edit/${cellData}`} className='btn btn-default btn-block btn-md LicenseMaintenance__btn-icon'>
                          <i className='fa fa-pencil-square-o fa-2x' style={{position: 'relative', top: 3}}></i>
                        </Link>
                      );
                    }}
                  />
                  <Column
                    width={66}
                    label='Delete'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData}) => {
                      return cellData === null ? '' : (
                        <Link to={`/admin/license-maintenance/delete/${cellData}`} className='btn btn-default btn-block btn-md LicenseMaintenance__btn-icon'>
                          <i className='fa fa-trash fa-2x'></i>
                        </Link>
                      );
                    }}
                  />
                </Table>
              )}
              </WindowScroller>
            ) : <p><em>There are currently no active licenses to display.</em></p> }
          </section>
        </Page>
        { modal }
      </div>
    );
  }
}

export default LicenseMaintenance;



// WEBPACK FOOTER //
// ./src/components/Admin/LicenseMaintenance.js